import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../../../pages/Error";
import Fallback from "../../atoms/Fallback";
import { useLocation } from "react-router-dom";

const PageSuspense = ({ children }) => {
  const location = useLocation();
  return (
    <ErrorBoundary fallbackRender={ErrorPage} key={location.pathname}>
      <Suspense fallback={<Fallback />}>{children}</Suspense>
    </ErrorBoundary>
  );
};

export default PageSuspense;
